import {
  IconChartBar,
  IconHelp,
  IconMicrophone,
  IconNotes,
  IconPill,
  IconTargetArrow,
  IconUser,
} from '@tabler/icons-react';

export const CLINICAL_PANEL_TAB_ITEMS = [
  { value: 'recording', label: 'Recording', icon: IconMicrophone },
  { value: 'overview', label: 'Overview', icon: IconUser },
  { value: 'notes', label: 'Note Taking', icon: IconNotes },
  { value: 'tx-plans', label: 'Treatment Plan', icon: IconTargetArrow },
  { value: 'assessments', label: 'Assessments', icon: IconChartBar },
  { value: 'help', label: 'Help', icon: IconHelp },
  { value: 'prescribe', label: 'E-Prescribe', icon: IconPill },
] as const;

export type ClinicalPanelTabValue = (typeof CLINICAL_PANEL_TAB_ITEMS)[number]['value'];

export function getEffectiveShowPrescribeTab(
  showPrescribeTab: boolean,
  isGroupTherapyEpisode: boolean,
): boolean {
  return showPrescribeTab && !isGroupTherapyEpisode;
}

/**
 * Visible clinical sidebar tabs for the current session type and prescribe authorization.
 */
export function getClinicalPanelVisibleTabs(
  isGroupTherapyEpisode: boolean,
  showPrescribeTab: boolean,
  includeRecordingTab = false,
): (typeof CLINICAL_PANEL_TAB_ITEMS)[number][] {
  const effectiveShowPrescribeTab = getEffectiveShowPrescribeTab(
    showPrescribeTab,
    isGroupTherapyEpisode,
  );
  return CLINICAL_PANEL_TAB_ITEMS.filter((tab) => {
    if (tab.value === 'recording' && !includeRecordingTab) return false;
    if (tab.value === 'assessments' && isGroupTherapyEpisode) return false;
    if (tab.value === 'prescribe' && !effectiveShowPrescribeTab) return false;
    return true;
  });
}
